import React, {CSSProperties, memo, type ReactNode} from 'react';
import {Input} from "@material-tailwind/react/components/Input";
import {getError, hasError} from "../hooks/errors";
import {useSelector} from "react-redux";
import {RootState} from "../store";

interface OutlineInputProps {
    validated: boolean,
    name: string,
    fieldName: string,
    value: string | number | undefined,
    readOnly?: boolean,
    onChange: (e: React.ChangeEvent<HTMLInputElement> | undefined) => void,
    type?: string,
    className?: string,
    style?: CSSProperties,
    icon?: ReactNode
}

const OutlineInput = ({
                          validated,
                          fieldName,
                          value,
                          name,
                          onChange,
                          type = 'text',
                          readOnly = false,
                          className,
                          style,
                          icon
                      }: OutlineInputProps) => {
    const errors = useSelector((state: RootState) => state.validation.errors);

    return <div className={`max-w-md mb-4 lg:mb-auto ${className ?? ''}`} style={style ?? undefined}>
        <Input success={!hasError(fieldName, errors) && validated}
               error={validated && hasError(fieldName, errors)} crossOrigin=''
               variant={'outlined'} label={name} type={type} onChange={onChange}
               value={value}
               readOnly={readOnly}
               className="inline-block dark:text-gray-500 dark:border-blue-gray-800 dark:placeholder-shown:border-blue-gray-800 dark:focus:border-blue-gray-800 dark:focus:border-t-transparent dark:placeholder-shown:border-t-transparent"
               labelProps={{className: "dark:after:border-blue-gray-800 dark:before:border-blue-gray-800 dark:peer-focus:text-white dark:peer-focus:before:!border-blue-gray-800 dark:peer-focus:after:!border-blue-gray-800"}}
               icon={icon}
        />
        {validated && hasError(fieldName, errors) &&
            <label key={'error-' + fieldName}
                   className="mt-1 text-red-500 text-xs block">{getError(fieldName, errors)}</label>}
    </div>
}

export default memo(OutlineInput);
